import Vue from 'vue'
export default {
  submitQuestion(content) {
    return Vue.http.post('assistant', {content}).then(res => res.body)
  }
}
